export const MESSAGES_LIST = "messages_list";
export const CALLS_LIST = "calls_list";
export const MEETINGS_LIST = "meetings_list"


export const CHATS = "chats"
export const CALLS = "calls"
export const NOTICES = "notices"
export const TRANSLATE = "translate";
export const TOOLS = "tools";
export const TOOLS_TRANSLATE = "tools_translate";
export const TOOLS_PRESENTATIONS = "tools_presentations";
export const TOOLS_VIDEO_TRANSLATION = "tools_video_translation";
export const TOOLS_CONVERSATION = "TOOLS_CONVERSATION";
export const TOOLS_LIVE_FEED = "TOOLS_LIVE_FEED";

export const TOOL_HINT_LIMIT = 10;
export const TOOL_HINT_PROBABILITY = 0.45;

export const PRODUCT_SLUG_PRESENTATIONS = "presentations";
export const PRODUCT_SLUG_VIDEO_TOOL = "video_tool";
export const PRODUCT_SLUG_CONFERENCES = "conferences";
export const PLATFORM_URL = process.env.REACT_APP_PLATFORM_URL || "https://platform.emotii.ai";
export const WEB_BASE_URL = process.env.REACT_APP_WEB_URL || window.location.origin;
export const CONTACTS = "contacts";
export const MEETINGS = "meetings";
export const CONFERENCES = "conferences";
export const PROFILE = "profile";
export const SETTINGS = "settings";
export const LANGUAGE = "language";
export const ACCOUNT = "account";
export const INTERFACE_LANGUAGES = "interface_languages";
export const APPEARANCE = "appearance";
export const HELP = "help";
export const INVITE = "invite";


export const AUTO = "auto";
export const MANUAL = "manual";
export const PHONE = "phone";
export const EMAIL = "email";

//MOOD CONSTANTS
export const ROMANTIC_MOOD = "romantic";
export const HUMOROUS_MOOD = "humorous";
export const CASUAL_MOOD = "casual";
export const NEUTRAL_MOOD = "neutral";
export const SUPPORTIVE_MOOD = "supportive";
export const BUSINESS_MOOD = "business";
export const FORMAL_MOOD = "formal";

export const SUBSCRIPTION_LEVEL_UNSUBSCRIBED = "not_subscribed";
export const SUBSCRIPTION_LEVEL_PREMIUM = "premium";
export const SUBSCRIPTION_LEVEL_PRO = "pro";
export const SUBSCRIPTION_LEVEL_ULTRA = "ultra";
export const SUBSCRIPTION_LEVEL_PLATFORM = "platform";
export const SUBSCRIPTION_LEVEL_REFERRALS = "referrals";

export const ACCESS_LEVEL_PRO = "pro";
export const ACCESS_LEVEL_ULTRA = "ultra";
export const ACCESS_LEVEL_PREMIUM = "premium";
export const ACCESS_LEVEL_PLATFORM = "platform";

export const ERROR_MEETING_INVALID_CODE = "ACCESS1007";
export const ERROR_MEETING_EXPIRED = "ACCESS1008";
export const ERROR_MEETING_CANCELLED = "ACCESS1010";
export const ERROR_MEETING_ROOM_DELETE_BLOCKED = "ACCESS1011";
export const ERROR_MEETING_WAITING_FOR_HOST = "ACCESS1012";
export const ERROR_MEETING_PRODUCT_UNAVAILABLE = "ACCESS1015";
export const ERROR_MEETING_NOT_OPEN = "ACCESS1018";
export const MEETING_OPEN_RETRY_MAX_MS = 15 * 60 * 1000;

export const MEETING_LIFECYCLE_STARTED = "meeting_started";
export const MEETING_LIFECYCLE_ENDED = "meeting_ended";
export const MEETING_ENDED_REASON_QUOTA_EXHAUSTED = "quota_exhausted";

export const MEETING_DISPLAY_ID_LENGTH = 9;
export const MEETING_PASSCODE_LENGTH = 6;

export const MEETING_STATUS_CHECK_INTERVAL_MS = 60000;
export const RECURRING_MEETING_MAX_SPAN_DAYS = 365;

export const AUDIO_SETTINGS = "audio"
export const VIDEO_SETTINGS = "video"
export const BACKGROUND_SETTINGS = "background"
export const LANGUAGE_SETTINGS = "language";
export const VOICE_CLONING = "voice_cloning";
export const VOICE_CLONING_SETTINGS = "voice_cloning_settings";

export const FEATURE_FLAGS = {
  VOICE_CLONING_IN_CALL: false,
  VIDEO_SUBTITLES: true,
  CONFERENCE_REQUEST_TO_SPEAK: false,
};

export const BLUR_BG = "blur"
export const MORE_BLUR_BG = "moreBlur"
export const IMAGE_BG = "image"
export const NORMAL_BG = "normal"


export const DARK_THEME = "dark"
export const LIGHT_THEME = "light"

export const CHAT = "chat"
export const GROUP = "group"
export const QUICK_CHAT = "quick_chat"

export const PERSONAL_ACCOUNT = "personal"
export const BUSINESS_ACCOUNT = "business"

export const SELECTED_MEMBERS = "selected_members"
export const ADD_MEMBERS = "add_members";
export const NEW_CONTACT = "new_contact"

// CONFERENCE ROLES
export const CONFERENCE_ROLE_ORGANIZER = "organizer";
export const CONFERENCE_ROLE_PRESENTER = "presenter";
export const CONFERENCE_ROLE_ATTENDEE = "attendee";

export const CONFERENCE_CHAT_AUDIENCE_PUBLIC = "public";
export const CONFERENCE_CHAT_AUDIENCE_PRIVATE = "private";

export const CONFERENCE_REGISTRATION_STATUS_PENDING = "pending";
export const CONFERENCE_REGISTRATION_STATUS_APPROVED = "approved";
export const CONFERENCE_REGISTRATION_STATUS_DENIED = "denied";


export const REAL_TIME_TRANSLATION = "real_time"
export const SEQUENCIAL_TRANSLATION = "sequential"
export const DISABLED_TRANSLATION = "disabled"

export const GALLERY_GRID_GAP = 10;
export const GALLERY_TARGET_TILE_WIDTH = 160;
export const GALLERY_MAX_COLUMNS = 6;

export const DRAFT_MESSAGES = 'draft_messages';
export const REPLY_STATE = 'reply_state';

export const MAX_POLLS = 5;
export const MAX_OPTIONS = 10;
export const MIN_OPTIONS = 2;

export const QUESTION_MIN_LENGTH = 3;
export const QUESTION_MAX_LENGTH = 500;
export const OPTION_MAX_LENGTH = 200;

export const POLL_STATUS_DRAFT = "draft";
export const POLL_STATUS_LAUNCHED = "launched";
export const POLL_STATUS_ENDED = "ended";

export const ANSWER_TYPE_SINGLE = "single";
export const ANSWER_TYPE_MULTIPLE = "multiple";

export const VOICE_SPEED_1X = "1x";
export const VOICE_SPEED_1_25X = "1.25x";
export const VOICE_SPEED_1_5X = "1.5x";

export const VOICE_VOLUME_0 = 0;
export const VOICE_VOLUME_25 = 25;
export const VOICE_VOLUME_50 = 50;
export const VOICE_VOLUME_75 = 75;
export const VOICE_VOLUME_100 = 100;

export const INCOMING_VOICE_MAX_GAIN = 0.9;

export const GENDER_OPTIONS = [
  { value: "male", key: "gender_selector.male", emoji: "👨" },
  { value: "female", key: "gender_selector.female", emoji: "👩" },
  { value: "non-binary", key: "gender_selector.non_binary", emoji: "🧑" },
  { value: "prefer_not_to_say", key: "gender_selector.prefer_not_to_say", emoji: "🚫" },
];

export const INTERFACE_TRANSLATION_LANGUAGES = [
    { name: 'English', translation: 'English', country_code: 'GB', locale: 'en-GB' },
    { name: 'Chinese', translation: '中文', country_code: 'CN', locale: 'zh-CN' },
    { name: 'Mandarin', translation: '普通话 / 國語', country_code: 'CN', locale: 'zh-CN' },
    { name: 'Hindi', translation: 'हिन्दी', country_code: 'IN', locale: 'hi-IN' },
    { name: 'Spanish', translation: 'Español', country_code: 'ES', locale: 'es-ES' },
    { name: 'Arabic', translation: 'العربية', country_code: 'SA', locale: 'ar-SA' },
    { name: 'Malay', translation: 'Bahasa Melayu', country_code: 'MY', locale: 'ms-MY' },
    { name: 'French', translation: 'Français', country_code: 'FR', locale: 'fr-FR' },
    { name: 'Indonesian', translation: 'Bahasa Indonesia', country_code: 'ID', locale: 'id-ID' },
    { name: 'Russian', translation: 'Русский', country_code: 'RU', locale: 'ru-RU' },
    { name: 'Bengali', translation: 'বাংলা', country_code: 'BD', locale: 'bn-BD' },
    { name: 'Portuguese', translation: 'Português', country_code: 'PT', locale: 'pt-PT' },
    { name: 'Brazilian Portuguese', translation: 'Português Brasileiro', country_code: 'BR', locale: 'pt-BR' },
    { name: 'Urdu', translation: 'اُردُو', country_code: 'PK', locale: 'ur-PK' },
    { name: 'Japanese', translation: '日本語', country_code: 'JP', locale: 'ja-JP' },
    { name: 'Persian (Farsi)', translation: 'فارسی', country_code: 'IR', locale: 'fa-IR' },
    { name: 'Punjabi', translation: 'ਪੰਜਾਬੀ', country_code: 'IN', locale: 'pa-IN' },
    { name: 'Swahili', translation: 'Kiswahili', country_code: 'KE', locale: 'sw-KE' },
    { name: 'Vietnamese', translation: 'Tiếng Việt', country_code: 'VN', locale: 'vi-VN' },
    { name: 'German', translation: 'Deutsch', country_code: 'DE', locale: 'de-DE' },
    { name: 'Marathi', translation: 'मराठी', country_code: 'IN', locale: 'mr-IN' },
    { name: 'Javanese', translation: 'ꦧꦱꦗꦮ / Basa Jawa', country_code: 'ID', locale: 'jv-ID' },
    { name: 'Telugu', translation: 'తెలుగు', country_code: 'IN', locale: 'te-IN' },
    { name: 'Turkish', translation: 'Türkçe', country_code: 'TR', locale: 'tr-TR' },
    { name: 'Rajasthani', translation: 'राजस्थानी', country_code: 'IN', locale: 'raj-IN' },
    { name: 'Wu', translation: '吴语', country_code: 'CN', locale: 'wuu-CN' },
    { name: 'Korean', translation: '한국어', country_code: 'KR', locale: 'ko-KR' },
    { name: 'Tamil', translation: 'தமிழ்', country_code: 'IN', locale: 'ta-IN' },
    { name: 'Thai', translation: 'ไทย', country_code: 'TH', locale: 'th-TH' },
    { name: 'Italian', translation: 'Italiano', country_code: 'IT', locale: 'it-IT' },
    { name: 'Cantonese (Yue)', translation: '粵語', country_code: 'HK', locale: 'yue-HK' },
    { name: 'Gujarati', translation: 'ગુજરાતી', country_code: 'IN', locale: 'gu-IN' },
    { name: 'Bhojpuri', translation: 'भोजपुरी', country_code: 'IN', locale: 'bho-IN' },
    { name: 'Hausa', translation: 'هَوُسَ / Hausa', country_code: 'NG', locale: 'ha-NG' },
    { name: 'Min Nan', translation: '闽南语', country_code: 'CN', locale: 'nan-CN' },
    { name: 'Oromo', translation: 'Afaan Oromoo', country_code: 'ET', locale: 'om-ET' },
    { name: 'Kannada', translation: 'ಕನ್ನಡ', country_code: 'IN', locale: 'kn-IN' },
    { name: 'Awadhi', translation: 'अवधी', country_code: 'IN', locale: 'awa-IN' },
    { name: 'Pashto', translation: 'پښتو', country_code: 'AF', locale: 'ps-AF' },
    { name: 'Sundanese', translation: 'Basa Sunda', country_code: 'ID', locale: 'su-ID' },
    { name: 'Ukrainian', translation: 'Українська', country_code: 'UA', locale: 'uk-UA' },
    { name: 'Malayalam', translation: 'മലയാളം', country_code: 'IN', locale: 'ml-IN' },
    { name: 'Polish', translation: 'Polski', country_code: 'PL', locale: 'pl-PL' },
    { name: 'Oriya (Odia)', translation: 'ଓଡ଼ିଆ', country_code: 'IN', locale: 'or-IN' },
    { name: 'Maithili', translation: 'मैथिली', country_code: 'IN', locale: 'mai-IN' },
    { name: 'Burmese', translation: 'မြန်မာစာ', country_code: 'MM', locale: 'my-MM' },
    { name: 'Uzbek', translation: 'Oʻzbekcha', country_code: 'UZ', locale: 'uz-UZ' },
    { name: 'Sindhi', translation: 'سنڌي / सिन्धी', country_code: 'PK', locale: 'sd-PK' },
    { name: 'Nepali', translation: 'नेपाली', country_code: 'NP', locale: 'ne-NP' },
    { name: 'Filipino', translation: 'Filipino', country_code: 'PH', locale: 'fil-PH' },
    { name: 'Haryanvi', translation: 'हरियाणवी', country_code: 'IN', locale: 'bgc-IN' },
    { name: 'Malagasy', translation: 'Malagasy', country_code: 'MG', locale: 'mg-MG' },
    { name: 'Igbo', translation: 'Asụsụ Igbo', country_code: 'NG', locale: 'ig-NG' },
    { name: 'Romanian', translation: 'Română', country_code: 'RO', locale: 'ro-RO' },
    { name: 'Azerbaijani', translation: 'Azərbaycan dili', country_code: 'AZ', locale: 'az-AZ' },
    { name: 'Dutch', translation: 'Nederlands', country_code: 'NL', locale: 'nl-NL' },
    { name: 'Tagalog', translation: 'Tagalog', country_code: 'PH', locale: 'tl-PH' },
    { name: 'Kurdish', translation: 'Kurdî / كوردی', country_code: 'IQ', locale: 'ku-IQ' },
    { name: 'Yoruba', translation: 'Èdè Yorùbá', country_code: 'NG', locale: 'yo-NG' },
    { name: 'Chhattisgarhi', translation: 'छत्तीसगढ़ी', country_code: 'IN', locale: 'hne-IN' },
    { name: 'Khmer', translation: 'ភាសាខ្មែរ', country_code: 'KH', locale: 'km-KH' },
    { name: 'Sinhala', translation: 'සිංහල', country_code: 'LK', locale: 'si-LK' },
    { name: 'Assamese', translation: 'অসমীয়া', country_code: 'IN', locale: 'as-IN' },
    { name: 'Somali', translation: 'Af-Soomaali', country_code: 'SO', locale: 'so-SO' },
    { name: 'Shona', translation: 'chiShona', country_code: 'ZW', locale: 'sn-ZW' },
    { name: 'Greek', translation: 'Ελληνικά', country_code: 'GR', locale: 'el-GR' },
    { name: 'Hungarian', translation: 'Magyar', country_code: 'HU', locale: 'hu-HU' },
    { name: 'Kazakh', translation: 'Қазақ тілі', country_code: 'KZ', locale: 'kk-KZ' },
    { name: 'Haitian Creole', translation: 'Kreyòl Ayisyen', country_code: 'HT', locale: 'ht-HT' },
    { name: 'Kinyarwanda', translation: 'Ikinyarwanda', country_code: 'RW', locale: 'rw-RW' },
    { name: 'Serbian', translation: 'Српски / Srpski', country_code: 'RS', locale: 'sr-RS' },
    { name: 'Zulu', translation: 'isiZulu', country_code: 'ZA', locale: 'zu-ZA' },
    { name: 'Czech', translation: 'Čeština', country_code: 'CZ', locale: 'cs-CZ' },
    { name: 'Swedish', translation: 'Svenska', country_code: 'SE', locale: 'sv-SE' },
    { name: 'Wolof', translation: 'Wolof', country_code: 'SN', locale: 'wo-SN' },
    { name: 'Hebrew', translation: 'עברית', country_code: 'IL', locale: 'he-IL' },
    { name: 'Turkmen', translation: 'Türkmençe', country_code: 'TM', locale: 'tk-TM' },
    { name: 'Tajik', translation: 'тоҷикӣ / تاجیکی', country_code: 'TJ', locale: 'tg-TJ' },
    { name: 'Xhosa', translation: 'isiXhosa', country_code: 'ZA', locale: 'xh-ZA' },
    { name: 'Afrikaans', translation: 'Afrikaans', country_code: 'ZA', locale: 'af-ZA' },
    { name: 'Bulgarian', translation: 'Български', country_code: 'BG', locale: 'bg-BG' },
    { name: 'Lao', translation: 'ພາສາລາວ', country_code: 'LA', locale: 'lo-LA' },
    { name: 'Tigrinya', translation: 'ትግርኛ', country_code: 'ER', locale: 'ti-ER' },
    { name: 'Kashmiri', translation: 'कॉशुर / کٲشُر', country_code: 'IN', locale: 'ks-IN' },
    { name: 'Armenian', translation: 'Հայերեն', country_code: 'AM', locale: 'hy-AM' },
    { name: 'Santali', translation: 'संताली', country_code: 'IN', locale: 'sat-IN' },
    { name: 'Albanian', translation: 'Shqip', country_code: 'AL', locale: 'sq-AL' },
    { name: 'Sesotho', translation: 'Sesotho', country_code: 'LS', locale: 'st-LS' },
    { name: 'Tatar', translation: 'Татар теле', country_code: 'RU', locale: 'tt-RU' },
    { name: 'Danish', translation: 'Dansk', country_code: 'DK', locale: 'da-DK' },
    { name: 'Croatian', translation: 'Hrvatski', country_code: 'HR', locale: 'hr-HR' },
    { name: 'Marwari', translation: 'मारवाड़ी', country_code: 'IN', locale: 'mwr-IN' },
    { name: 'Finnish', translation: 'Suomi', country_code: 'FI', locale: 'fi-FI' },
    { name: 'Norwegian', translation: 'Norsk', country_code: 'NO', locale: 'no-NO' },
    { name: 'Slovak', translation: 'Slovenčina', country_code: 'SK', locale: 'sk-SK' },
    { name: 'Mongolian', translation: 'Монгол хэл', country_code: 'MN', locale: 'mn-MN' },
    { name: 'Kyrgyz', translation: 'Кыргыз тили', country_code: 'KG', locale: 'ky-KG' },
    { name: 'Belarusian', translation: 'Беларуская', country_code: 'BY', locale: 'be-BY' },
    { name: 'Catalan', translation: 'Català', country_code: 'ES', locale: 'ca-ES' },
    { name: 'Georgian', translation: 'ქართული', country_code: 'GE', locale: 'ka-GE' },
    { name: 'Hmong', translation: 'Hmoob', country_code: 'CN', locale: 'hmn-CN' },
    { name: 'Bosnian', translation: 'Bosanski', country_code: 'BA', locale: 'bs-BA' },
    { name: 'Lithuanian', translation: 'Lietuvių kalba', country_code: 'LT', locale: 'lt-LT' },
    { name: 'Moldovan (Romanian)', translation: 'Română', country_code: 'MD', locale: 'ro-MD' },
    { name: 'Konkani', translation: 'कोंकणी', country_code: 'IN', locale: 'kok-IN' },
    { name: 'Galician', translation: 'Galego', country_code: 'ES', locale: 'gl-ES' },
    { name: 'Dogri', translation: 'ڈوگری / डोगरी', country_code: 'IN', locale: 'doi-IN' },
    { name: 'Macedonian', translation: 'Македонски јазик', country_code: 'MK', locale: 'mk-MK' },
    { name: 'Slovenian (Slovene)', translation: 'Slovenščina', country_code: 'SI', locale: 'sl-SI' },
    { name: 'Irish', translation: 'Gaeilge', country_code: 'IE', locale: 'ga-IE' },
    { name: 'Latvian', translation: 'Latviešu valoda', country_code: 'LV', locale: 'lv-LV' },
    { name: 'Yiddish', translation: 'ייִדיש', country_code: 'IL', locale: 'yi-IL' },
    { name: 'Bashkir', translation: 'Башҡорт теле', country_code: 'RU', locale: 'ba-RU' },
    { name: 'Estonian', translation: 'Eesti', country_code: 'EE', locale: 'et-EE' },
    { name: 'Basque', translation: 'Euskara', country_code: 'ES', locale: 'eu-ES' },
    { name: 'Welsh', translation: 'Cymraeg', country_code: 'GB', locale: 'cy-GB' },
    { name: 'Luxembourgish', translation: 'Lëtzebuergesch', country_code: 'LU', locale: 'lb-LU' },
    { name: 'Maori', translation: 'Te Reo Māori', country_code: 'NZ', locale: 'mi-NZ' },
    { name: 'Maltese', translation: 'Malti', country_code: 'MT', locale: 'mt-MT' },
    { name: 'Icelandic', translation: 'Íslenska', country_code: 'IS', locale: 'is-IS' },
    { name: 'Montenegrin', translation: 'Crnogorski', country_code: 'ME', locale: 'sr-ME' },
    { name: 'Samoan', translation: 'Gagana fa\'a Sāmoa', country_code: 'WS', locale: 'sm-WS' },
    { name: 'Sanskrit', translation: 'संस्कृतम्', country_code: 'IN', locale: 'sa-IN' },
    { name: 'Tongan', translation: 'lea fakatonga', country_code: 'TO', locale: 'to-TO' },
    { name: 'Faroese', translation: 'Føroyskt', country_code: 'FO', locale: 'fo-FO' },
    { name: 'Scots Gaelic', translation: 'Gàidhlig', country_code: 'GB', locale: 'gd-GB' }
].sort((a, b) =>a.name.localeCompare(b.name))
